import * as React from 'react';
import classnames from 'classnames';
import Base, { Props as BaseProps, TypeColors } from '../Base/Base';
import { rgbMap } from '../variables';
import './Skeleton.css';

export interface Props extends BaseProps {
  /** Flag to enable/disable the loading behaviour */
  active?: boolean;
  /** Color of the Skeleton */
  color?: TypeColors;
}

/**
 * Container for the skeleton loading pattern. All skeleton
 * children should exist within a Skeleton component, but
 * it is not restricted to just skeleton components.
 */
const Skeleton: React.FunctionComponent<Props> = (props: Props) => {
  const { active, color = 'white', ...rest } = props;
  const rgb = rgbMap[color];
  const classes = classnames('Skeleton', {
    'Skeleton--active': active,
  });

  return (
    <Base { ...rest }
        className={ classes }
        style={ { '--Skeleton--color': rgb.toString() } } />
  );
};

Skeleton.defaultProps = {
  color: 'white',
};

export default Skeleton;
